import React from 'react';
import './Section_11.css';
import { DynamicIcon } from 'lucide-react/dynamic';


function Section11({ sectionConfig }) {
  if (!sectionConfig || !sectionConfig.items) return null;
 const getLucideIcon = (iconName, size =35) => {
              if (!iconName) return null;
              return <DynamicIcon name={iconName} size={size} />;
            };


  const gridStyle = {
    display: "grid",
    gridTemplateColumns: `repeat(${sectionConfig.itemCount}, 1fr)`,
    gap: "30px",
  };

  return (
    <section className="section-11">
      {/* Top Heading Block */}
      <div className="section-11-header">
        <h3 className="section-11-heading">{sectionConfig.heading}</h3>
        <h1 className="section-11-title">{sectionConfig.title}</h1>
        <h2 className="section-11-subtitle">{sectionConfig.subtitle}</h2>
      </div>

      {/* Item Cards */}
      <div className="item-grid" style={gridStyle}>
        {sectionConfig.items.map((item, idx) => (
          <div key={idx} className="item-card">
            <div className="item-icon">{getLucideIcon(item.icon)|| '⭐'}</div>
            <div className="item-count">{item.count}</div>
            <div className="item-title">{item.title}</div>
            <div className="item-subtitle">{item.subtitle}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Section11;